export default {
  title: 'A importação está em curso... 🙂',
  description: 'Serão enviadas notificações Slack quando a importação terminar.',
  buttons: {
    open_followers_list: 'Abrir lista de seguidores',
  },
};
